import React from "react";

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <a className="navbar-brand" href="/">
            SYNTAX MAP
          </a>
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="/about">About</a>
            </li>
            <li>
              <a href="/features">Features</a>
            </li>
            <li>
              <a href="/tensemap">Tensemap</a>
            </li>
            <li>
              <a href="/trialexam">Trial Exam</a>
            </li>
            <li>
              <a href="/notepad">Notepad</a>
            </li>
            <li>
              <a href="/multiplayer">Multiplayer</a>
            </li>
            <li className="dropdown">
              <a href="/login" className="dropdown-toggle" data-toggle="dropdown">Login <b className="caret"></b></a>
              <ul className="dropdown-menu">
                <li><a href="/login">Login</a></li>
                <li><a href="https://admin-final.vercel.app/login" target="_blank" rel="noopener noreferrer">Admin Panel</a></li>
              </ul>
            </li>
            <li>
              <a href="/contact">Contact</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
